import { lazy } from 'react';
import { Routes } from '@bootstrap/router';

export const ROUTES = {
  NOT_FOUND: '*',
  ABOUT_US: '/about-us',
  CENTRE: '/service-centres',
  CENTRE_DETAILS: '/service-centres/',
  DISCLAIMER: '/disclaimer',
  FORM: '/booking',
  FORM_CAR: '/booking/car',
  FORM_SERVICE: '/booking/service',
  FORM_BOOKING: '/booking/booking-detail',
  FORM_PERSONAL: '/booking/personal-inforrmation',
  FORM_CONFIRMATION: '/booking/confirmation',
  FORM_SUCCESS: '/booking/success',
  AMEND_FORM: '/amend-form',
  AMEND_FORM_VERIFY: '/amend-form/verification',
  AMEND_FORM_SELECT: '/amend-form/select',
  AMEND_FORM_PREVIEW: '/amend-form/preview',
  AMEND_FORM_CAR: '/amend-form/car',
  AMEND_FORM_SERVICE: '/amend-form/service',
  AMEND_FORM_BOOKING: '/amend-form/booking-detail',
  AMEND_FORM_PERSONAL: '/amend-form/personal-inforrmation',
  AMEND_FORM_CANCEL: '/amend-form/cancel',
  HOME: '/',
  NEWS: '/news',
  NEWS_DETAILS: '/news/',
  PRIVACY: '/privacy',
  TNC: '/tnc',
  INTERNAL_NOT_FOUND: '/internal/*',
  INTERNAL_HOME: '/internal-booking',
  INTERNAL: '/internal/booking',
  INTERNAL_CUSTOMER: '/internal/booking/customer-vehicle-information',
  INTERNAL_RESOURCES: '/internal/booking/resources-timeslot',
  INTERNAL_ORDER: '/internal/booking/customer-order-request',
  INTERNAL_PREVIEW: '/internal/booking/order-previews-confirmation',
  INTERNAL_ACCOUNT: '/internal/account',
  INTERNAL_DASHBOARD: '/internal/dashboard'
};

export const routes: Routes = [
  // Basic case
  {
    path: ROUTES.HOME,
    exact: true,
    component: lazy(() => import('./views/home/Home')),
  },
  {
    path: ROUTES.FORM,
    exact: false,
    component: lazy(() => import('./views/form/Form')),
  },
  {
    path: ROUTES.AMEND_FORM,
    exact: false,
    component: lazy(() => import('./views/amend-form/AmendForm')),
  },
  {
    path: ROUTES.ABOUT_US,
    exact: true,
    component: lazy(() => import('./views/about-us/AboutUs')),
  },
  {
    path: ROUTES.CENTRE,
    exact: true,
    component: lazy(() => import('./views/centre/Centre')),
  },
  {
    path: ROUTES.CENTRE_DETAILS,
    exact: false,
    component: lazy(() => import('./views/centre/CentreDetail')),
  },
  {
    path: ROUTES.DISCLAIMER,
    exact: true,
    component: lazy(() => import('./views/disclaimer/Disclaimer')),
  },
  {
    path: ROUTES.NEWS,
    exact: true,
    component: lazy(() => import('./views/news/News')),
  },
  {
    path: ROUTES.NEWS_DETAILS,
    exact: false,
    component: lazy(() => import('./views/news/NewsDetails')),
  },
  {
    path: ROUTES.PRIVACY,
    exact: true,
    component: lazy(() => import('./views/privacy/Privacy')),
  },
  {
    path: ROUTES.TNC,
    exact: true,
    component: lazy(() => import('./views/tnc/TnC')),
  },
  {
    path: ROUTES.INTERNAL_HOME,
    exact: true,
    component: lazy(() => import('./views/internal/InternalHome')),
  },
  {
    path: ROUTES.INTERNAL,
    exact: false,
    component: lazy(() => import('./views/internal/Internal')),
  },
  {
    path: ROUTES.INTERNAL_ACCOUNT,
    exact: true,
    component: lazy(() => import('./views/internal/InternalAccount')),
  },
  {
    path: ROUTES.INTERNAL_DASHBOARD,
    exact: true,
    component: lazy(() => import('./views/internal/InternalDashboard')),
  },
  // {
  //   path: ROUTES.INTERNAL_NOT_FOUND,
  //   exact: true,
  //   component: lazy(() => import('./views/internal/InternalNotFound')),
  // },
  {
    path: ROUTES.NOT_FOUND,
    exact: true,
    component: lazy(() => import('./views/not-found/NotFound')),
  }
];
